import React, { FC } from 'react';
import MuiFab, { FabProps as MuiFabProps } from '@mui/material/Fab';
import { BpDesignSystem } from '../../types';

export type FabProps = BpDesignSystem.PropsWithChildren<
  Omit<MuiFabProps, 'color'> & {
    color?: 'primary' | 'secondary' | 'default';
  }
>;

export const Fab: FC<FabProps> = ({ dataTest, ...props }) => <MuiFab data-test={dataTest} {...props} />;
